import { defineMessages } from 'react-intl';

var messages = defineMessages({
  next: {
    id: "neptune.DateLookup.next"
  },
  previous: {
    id: "neptune.DateLookup.previous"
  },
  day: {
    id: "neptune.DateLookup.day"
  },
  month: {
    id: "neptune.DateLookup.month"
  },
  year: {
    id: "neptune.DateLookup.year"
  },
  twentyYears: {
    id: "neptune.DateLookup.twentyYears"
  },
  selected: {
    id: "neptune.DateLookup.selected"
  },
  goTo20YearView: {
    id: "neptune.DateLookup.goTo20YearView"
  }
});

export { messages as default };
//# sourceMappingURL=DateLookup.messages.mjs.map
